<template>
  <el-dialog
    :title="DIALOG_TITLE_TYPE[dialogType]"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="100px"
      style="width: 80%; margin-left:50px;"
    >
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" />
      </el-form-item>
      <el-form-item label="活动时间" prop="timeRange">
        <el-date-picker
          v-model="form.timeRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="width: 100%;"
          @change="handleTimeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择活动状态" style="width: 100%">
          <el-option
            v-for="item in ACTIVITY_STATUS"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="活动总限购" prop="totalLimit">
        <el-input-number v-model="form.totalLimit" :min="0"></el-input-number>
        <span style="color: #999; font-size: 12px; margin-left: 10px;">0表示不限购</span>
      </el-form-item>
      <el-form-item label="单次限购" prop="singleLimit">
        <el-input-number
          v-model="form.singleLimit"
          :min="0"
          placeholder="0表示不限"
        ></el-input-number>
        <span style="color: #999; font-size: 12px; margin-left: 10px;">0表示不限购</span>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="form.sort" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="btnLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { ACTIVITY_STATUS, DIALOG_TITLE_TYPE } from "@/utils/enumUtile";

export default {
  name: "ActivityForm",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "CREATE"
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    btnLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ACTIVITY_STATUS() {
      return ACTIVITY_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    }
  },
  data() {
    return {
      form: {
        id: null,
        name: null,
        timeRange: [],
        startTime: null,
        endTime: null,
        status: 1,
        totalLimit: 0,
        singleLimit: 0,
        sort: null
      },
      rules: {
        name: [{ required: true, message: "活动名称不能为空", trigger: "blur" }],
        timeRange: [{ required: true, message: "活动时间不能为空", trigger: "change" }]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
    editData: {
      handler(val) {
        if (this.visible) {
          this.initForm();
        }
      },
      deep: true
    }
  },
  methods: {
    handleTimeChange(val) {
      if (val && val.length === 2) {
        this.form.startTime = moment(val[0]).unix() * 1000;
        this.form.endTime = moment(val[1]).unix() * 1000;
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
    },
    initForm() {
      if (this.dialogType === "UPDATE" && this.editData && Object.keys(this.editData).length > 0) {
        this.form = {
          id: this.editData.id,
          name: this.editData.name || null,
          timeRange:
            this.editData.startTime && this.editData.endTime
              ? [new Date(this.editData.startTime), new Date(this.editData.endTime)]
              : [],
          startTime: this.editData.startTime || null,
          endTime: this.editData.endTime || null,
          status: this.editData.status !== undefined ? this.editData.status : 1,
          totalLimit: this.editData.totalLimit !== undefined ? this.editData.totalLimit : 0,
          singleLimit: this.editData.singleLimit !== undefined ? this.editData.singleLimit : 0,
          sort: this.editData.sort || null
        };
      } else {
        this.form = {
          id: null,
          name: null,
          timeRange: [],
          startTime: null,
          endTime: null,
          status: 1,
          totalLimit: 0,
          singleLimit: 0,
          sort: null
        };
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }
      }
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = { ...this.form };
          delete params.timeRange;
          if (params.id === null) {
            delete params.id;
          }
          this.$emit("confirm", params);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
